import { useState } from 'react';
import { Eye, EyeOff, Lock } from 'lucide-react';
import type { UseFormRegisterReturn } from 'react-hook-form';

interface PasswordInputProps {
  id: string;
  registration: UseFormRegisterReturn;
  placeholder?: string;
  autoComplete?: string;
  invalid?: boolean;
}

export function PasswordInput({
  id,
  registration,
  placeholder,
  autoComplete = 'current-password',
  invalid,
}: PasswordInputProps) {
  const [show, setShow] = useState(false);
  return (
    <div className="input-wrapper">
      <Lock size={20} strokeWidth={2} />
      <input
        type={show ? 'text' : 'password'}
        id={id}
        className="form-input"
        placeholder={placeholder}
        autoComplete={autoComplete}
        aria-invalid={invalid}
        {...registration}
      />
      <button
        type="button"
        className="toggle-password"
        onClick={() => setShow((s) => !s)}
        aria-label="Toggle password visibility"
      >
        {show ? <EyeOff size={20} strokeWidth={2} /> : <Eye size={20} strokeWidth={2} />}
      </button>
    </div>
  );
}
